import { Layout } from 'antd';
import React from 'react';
import { Outlet } from 'react-router';
import AppHeader from '../App/Header';
import Drawer from '../App/Drawer';
import { ScrollRestoration } from 'react-router-dom';
import { IQCAdminApp } from '../containers/IQCAdminApp';

const DashboardLayout = () => {
  const containerRef = React.useRef<HTMLDivElement>(null);
  return (
    <IQCAdminApp containerRef={containerRef}>
      <Layout style={{ height: '100%' }} hasSider>
        <Drawer></Drawer>
        <Layout>
          <AppHeader></AppHeader>
          <Layout.Content
            ref={containerRef}
            style={{ padding: 16, overflow: 'auto' }}
          >
            <ScrollRestoration />
            <Outlet></Outlet>
          </Layout.Content>
          {/* <Layout.Footer>Footer</Layout.Footer> */}
        </Layout>
      </Layout>
    </IQCAdminApp>
  );
};

export default DashboardLayout;
